import UploadOutlined from '@ant-design/icons/lib/icons/UploadOutlined';
import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Select,
  Spin,
  Upload,
} from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import {
  alarmFormItem,
  JiraFormItemType,
  jiraFormConfig,
  jiraTypeOptions,
} from './constant';
import AllActionTypes from '../../redux/actionType';
import {
  actionInitTimestampFlag,
  actionSendHttpRequest,
} from '../../redux/action';
import { enumTranslator, formatSelectOptions, isEmpty } from '../../utils';
// eslint-disable-next-line no-unused-vars
import { formatJiraSubmit } from '../Keys/utils/format';
import { LoginState } from '../../redux/type';
import './index.scss';
import { api } from '../../fetch/bussiness/api';
import { HttpStatusCode } from '../../fetch/core/constant';
import { cloneDeep, debounce } from 'lodash';

import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
interface Props {
  vehicleName: string;
  stationName: string; // 问题提报详情字段，需要该字段
  title?: string;
  submitTime?: object;
  issueNo: string;
  jiraItem?: boolean;
  alarmItem?: boolean;
  basicItem?: boolean;
  accidentNo?: string;
  onClose?: AnyFunc;
  initFromData?: any;
  accidentData?: any;
}
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};

const formatAlarmListOption = (array: []) => {
  if (isEmpty(array)) {
    return [];
  }
  const options: {
    label: string;
    value: string;
  }[] = [];
  array.forEach((item: any, index: any) => {
    const alarmName = enumTranslator('ALARM_EVENT_ENUM', item.type);
    options.push({
      label: `${alarmName}  ${dayjs(item.startTimestamp).format('HH:mm:ss')}`,
      value: index,
    });
  });
  return options;
};
export const getRoverVersionList = async () => {
  const param = {
    path: '/monitor/web/jira/get_rover_list',
    method: 'POST',
  };

  return await request(param);
};

const levelList = formatSelectOptions(
  localStorage.getItem('ENUM_LIST_MAP') &&
    JSON.parse(localStorage.getItem('ENUM_LIST_MAP') || '{}')[
      'PRELIMINARY_ACCIDENT_LEVEL_ENUM'
    ],
);
const typeList = formatSelectOptions(
  localStorage.getItem('ENUM_LIST_MAP') &&
    JSON.parse(localStorage.getItem('ENUM_LIST_MAP') || '{}')[
      'PRELIMINARY_ACCIDENT_TYPE_ENUM'
    ],
);
const severityList = formatSelectOptions(
  localStorage.getItem('ENUM_LIST_MAP') &&
    JSON.parse(localStorage.getItem('ENUM_LIST_MAP') || '{}')[
      'BUG_SEVERITY_ENUM'
    ],
);
const { TextArea } = Input;
const OptimizeJira = (props: Props) => {
  const { submitTime, vehicleName, issueNo, stationName, accidentData } = props;
  const store = (window as any).store;
  const state = store.getState();
  const { alarmAndOpenration } = state.common;
  const [modalVisible, setModalVisible] = useState(true);
  const [showImgList, setShowImgList] = useState<any>([]);
  const [timeList, setTimeList] = useState<any>([]);

  const [versionList, setVersionList] = useState<any>([]);
  const customValidatorRef = useRef<any>([]);
  const [jiraFormData, setJiraFormData] = useState<any>([]);
  const [form] = Form.useForm();
  const [showBasicFlag, setShowBasicFlag] = useState(
    props.jiraItem ? false : props.basicItem ? true : false,
  );
  const [initBasicVehicle, setInitBasicVehicle] = useState<any>(null); // 车辆基本数据信息
  const [initIssueDetail, setInitIssueDetail] = useState<any>(null); // 初始化工单基本信息
  const jiraFormRef = useRef<any>(cloneDeep(jiraFormConfig));
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (timeList.length === 0 && submitTime) {
      setTimeList([dayjs(submitTime).format('YYYY-MM-DD HH:mm:ss')]);
      form.setFieldsValue({
        debugTime: [dayjs(submitTime).format('YYYY-MM-DD HH:mm:ss')],
      });
    }
  }, [submitTime]);

  useEffect(() => {
    if (state.login.state === LoginState.LOGINED) {
      setInitFormDataByAlarm();
      getRoverVersionList().then((res) => {
        if (res.code === HttpStatusCode.Success) {
          if (!isEmpty(res.data)) {
            setVersionList(
              res.data.map((item: string) => {
                return {
                  label: item,
                  value: item,
                };
              }),
            );
          }
        }
      });
    } else {
      handleClose();
    }
  }, [state.login]);
  // 初始化车辆基本信息、初始化工单报警事件
  useEffect(() => {
    jiraFormRef.current?.data?.forEach((item: any) => {
      jiraFormRef.current?.linkRules?.forEach((rules: any) => {
        if (item.name === rules.linkFieldName) {
          customValidatorRef.current.push({
            name: item.name,
            rules: item.rules,
          });
        }
      });
    });
    jiraFormConfig?.data?.forEach((item: any) => {
      jiraFormConfig?.linkRules?.forEach((rules: any) => {
        if (item.name === rules.linkFieldName) {
          customValidatorRef.current.push({
            name: item.name,
            rules: item.rules,
          });
        }
      });
    });

    if (state.login.state === LoginState.LOGINED && !props.accidentNo) {
      getAlarmDetailInfo();
      getVehicleInfo();
    }
  }, []);
  useEffect(() => {
    const basic: any = jiraFormConfig.data;
    if (props.alarmItem) {
      if (showBasicFlag) {
        const newBasic = basic.map((item: any) => {
          if (item.name === 'accidentLevel') {
            return {
              ...item,
              hidden: true,
            };
          }
          return item;
        });
        jiraFormRef.current.data = [...alarmFormItem, ...newBasic];
      } else {
        jiraFormRef.current.data = [...alarmFormItem];
      }
    } else {
      jiraFormRef.current.data = [...basic];
    }
    const formatData = formatFormData(cloneDeep(jiraFormRef.current));
    setJiraFormData(formatData);
  }, [showBasicFlag]);
  useEffect(() => {
    if (initIssueDetail && initIssueDetail.historyList) {
      let des = '';
      initIssueDetail.historyList.map((item: any) => {
        if (item.operateTitle === '报警信息') {
          if (item.operateMsg)
            des += `【${item.operateTitle}】${item.operateMsg}  `;
        } else {
          des += `【${item.operateTitle}】${dayjs(item.operateTime).format(
            'YYYY-MM-DD HH:mm:ss',
          )} `;
          if (item.operateUser) des += `${item.operateUser}  `;
          if (item.operateMsg) des += `${item.operateMsg}  `;
        }
        if (des.length) des += `\n`;
      });
      form.setFieldsValue({
        description: des,
      });
    }
  }, [initIssueDetail]);

  const formatFormData = (formData: any) => {
    return {
      ...formData,
      data: formData?.data?.map((item: any) => {
        if (item.hidden) {
          return {
            ...item,
            rules: false,
          };
        }
        return item;
      }),
    };
  };

  const radioOptionsMap = new Map([
    [
      'alarm',
      initIssueDetail && formatAlarmListOption(initIssueDetail.alarmList),
    ],
    ['isCrash', jiraTypeOptions],
  ]);
  const selectOptionsMap = new Map([
    ['accidentLevel', levelList],
    ['accidentType', typeList],
    ['severity', severityList],
    ['version', versionList],
  ]);
  const onFieldsChange = (changedValues: any, allValues: any) => {
    const changedValue = changedValues[0];
    const changedName = changedValue?.name[0];

    // Iterate through the link rules in the form data
    for (const i of jiraFormData?.linkRules || []) {
      if (i.fieldName === changedName) {
        const { linkFieldName, type, visibleRule } = i;

        if (type.includes('visible') && visibleRule) {
          const { show } = visibleRule;

          // Find the link field in the form data
          const linkField = jiraFormData.data.find(
            (field: any) => field.name === linkFieldName,
          );
          // Update the visibility of the link field
          linkField.hidden = !show.includes(changedValue.value);
          // Update the required validation rule of the link field
          customValidatorRef.current.forEach((item: any) => {
            if (linkField.name === item.name && !linkField.hidden) {
              linkField.rules = cloneDeep(item.rules);
            } else if (linkField.name === item.name && linkField.hidden) {
              if (linkField?.rules) {
                linkField.rules = false;
              }
            }
          });
        }
      }
    }
    // Update the form data
    setJiraFormData({ ...jiraFormData });
  };

  // jira图片上传
  const customRequest = (option: any) => {
    const newFileList = [...showImgList, option.file];
    setShowImgList(newFileList);
    const reader = new FileReader();
    reader.readAsDataURL(option.file);
    reader.onloadend = function (e: any) {
      option.onSuccess();
    };
  };
  const onRemove = (file: any) => {
    const newFileList = showImgList.filter(
      (item: any) => item.uid !== file.uid,
    );
    setShowImgList(newFileList);
  };
  const toFormData = (data: any) => {
    if (data === null) return null;
    return Object.keys(data).reduce((formData, item) => {
      if (item === 'attachment') {
        // 特殊判断如果内容为files数组，就直接append
        data[item] &&
          data[item].forEach((curr: any) => {
            formData.append('attachment', curr);
          });
      } else if (item === 'debugTime') {
        // debugTime数组单独处理
        data[item] &&
          data[item].forEach((time: any) => {
            formData.append('debugTime', time);
          });
      } else {
        formData.append(item, data[item]);
      }
      return formData;
    }, new FormData());
  };

  const submit = async () => {
    const formData = await form.validateFields();
    let flag = true;
    const concatValues = {
      ...formData,
      attachment: showImgList,
      stationName:
        (alarmAndOpenration && alarmAndOpenration.stationName) ||
        (initBasicVehicle && initBasicVehicle.stationName),
    };
    for (const key in concatValues) {
      if (key === 'debugTime' && concatValues[key].length === 0) {
        message.info('发生时间不能为空');
        flag = false;
        break;
      }
    }
    if (flag) {
      setLoading(true);
      const param = formatJiraSubmit(concatValues, vehicleName, stationName);
      const selectedAlarm = initIssueDetail?.alarmList?.find(
        (item: any, index: number) => {
          return formData.alarm == index;
        },
      );
      const workOrderParam = {
        ...param,
        issueNo: props?.accidentNo ? props?.accidentNo : props.issueNo,
        jiraSource: props?.accidentNo ? 'ACCIDENT' : 'ISSUE',
        selectedAlarm: (selectedAlarm && selectedAlarm.type) || '',
      };
      const jiraParam = workOrderParam;
      const submitData: RequestOptions = {
        method: 'POST',
        absoluteURL:
          location.protocol +
          '//' +
          process.env.JDX_APP_FETCH_DATA_DOMAIN +
          api.submitJira,
        contentType: 'formData',
        body: toFormData(jiraParam),
      };
      request(submitData).then((resp) => {
        setLoading(false);
        if (resp.code == HttpStatusCode.Success) {
          message.success('提报成功');
          props.onClose && props.onClose();
          handleClose();
        } else {
          message.error(resp.message);
        }
      });
    }
  };

  // 关闭弹窗
  const handleClose = () => {
    setModalVisible(false);
    (window as any).store.dispatch(
      actionInitTimestampFlag(AllActionTypes.ISSUE_INIT_STATE),
    );
    const el = document.getElementById('jiraModal');
    if (el) {
      el.parentElement && el.parentElement.removeChild(el);
    }
  };

  const handleSelectTime = (value: string[]) => {
    setTimeList([...value]);
    form.setFieldsValue({
      debugTime: value,
    });
  };
  const changeTime = (value: any) => {
    if (value) {
      onOk(value);
    }
  };

  const onOk = (value: any) => {
    const repeat: any[] = timeList.filter(
      (item: any) => item === dayjs(value.$d).format('YYYY-MM-DD HH:mm:ss'),
    );
    if (repeat.length > 0) {
      message.info('时间有重复，请重新选择');
    } else {
      const newTimeList: any = [
        ...timeList,
        dayjs(value.$d).format('YYYY-MM-DD HH:mm:ss'),
      ];
      setTimeList(newTimeList);
      form.setFieldsValue({
        debugTime: newTimeList,
      });
    }
  };

  const getAlarmDetailInfo = () => {
    const issueDetail: HTTPFetchActionParams = {
      method: Method.POST,
      path: api.getWorkOrderDetail,
      body: {
        vehicleName: vehicleName,
        issueNo: issueNo,
      },
      actionType: '',
      nextActionFunc: (resp) => {
        if (resp.code === HttpStatusCode.Success) {
          setInitIssueDetail(resp.data.data);
        } else {
          message.error(resp.code);
        }
      },
    };
    const win = window as any;
    win.store.dispatch(actionSendHttpRequest(issueDetail));
  };
  const getVehicleInfo = () => {
    const vehicleInfo: any = {
      method: Method.POST,
      path: `${api.getVehicleInfo}`,
      body: {
        vehicleName,
      },
      nextActionFunc: (resp: any) => {
        if (resp.code != '0000') {
          message.error(resp.message);
        } else {
          setInitBasicVehicle(resp.data.data);
        }
      },
    };
    const win = window as any;
    win.store.dispatch(actionSendHttpRequest(vehicleInfo));
  };

  // 回显当前车报警的表单信息
  const setInitFormDataByAlarm = () => {
    const titleArr: any[] = [];
    const describeArr: any[] = [];
    const timeArr: any[] = [];
    if (initIssueDetail && !isEmpty(initIssueDetail.alarmList)) {
      initIssueDetail.alarmList.map((item: any) => {
        let description = '';
        if (item.startTimestamp) {
          const eventDate = dayjs(item.startTimestamp).format(
            'YYYY-MM-DD HH:mm:ss',
          );
          description = eventDate;
          timeArr.push(eventDate);
        }
        if (item && item.type) {
          titleArr.push(item.type);
          description += `【报警事件】${item.type}`;
          describeArr.push(description);
        }
      });
      form.setFieldsValue({
        jira: titleArr.join('；'),
        description: describeArr.join('；'),
      });
      setTimeList(timeArr);
    }
  };
  // 根据选择不同的报警事件,回显表单数据
  const setFormDataByAlarmEvent = (value: any) => {
    const selectedAlarm =
      initIssueDetail.alarmList &&
      initIssueDetail.alarmList.find((item: any, index: number) => {
        return value == index;
      });
    if (selectedAlarm) {
      form.setFieldsValue({
        jira: enumTranslator('ALARM_EVENT_ENUM', selectedAlarm.type),
      });
      setTimeList([
        dayjs(selectedAlarm.startTimestamp).format('YYYY-MM-DD HH:mm:ss'),
      ]);
    }
  };
  const getMatchVersionId = (
    versionList: { id: number; name: string }[],
    vehicleVersion: string,
  ) => {
    const reg = /_engine$/g;
    let selectId: string | number | undefined | null = null;
    const arr = reg.exec(vehicleVersion);
    if (arr !== null) {
      selectId = versionList.find(
        (item) =>
          item.name === vehicleVersion.substring(0, arr?.index) ||
          item.name === vehicleVersion,
      )?.id;
    } else if (arr === null) {
      selectId = versionList.find((item) => item.name === vehicleVersion)?.id;
    }
    return selectId ? String(selectId) : null;
  };
  const renderJiraForm = () => {
    let initialValues = {};
    if (props?.accidentNo) {
      const topic = ' ';
      initialValues = {
        topic,
        accidentLevel: props.accidentData?.accidentLevel || null,
        accidentType: props.accidentData?.accidentType || null,
        isCrash: '1',
        severity: (severityList && severityList[1]) || null,
        version: props.accidentData?.roverVersion || null,
        follower: '',
      };
    } else {
      initialValues = {
        isCrash: '0',
        severity: (severityList && severityList[2]) || null,
        follower: '',
      };
    }

    return (
      <div>
        <Form
          className='my-form'
          {...layout}
          id='problemForm'
          name='control-ref'
          autoComplete='off'
          initialValues={initialValues}
          form={form}
          onFieldsChange={onFieldsChange}
          onValuesChange={(changedFields, allFields) => {
            if (Object.keys(changedFields)[0] === 'alarm') {
              if (typeof Object.values(changedFields)[0] === 'number') {
                setFormDataByAlarmEvent(Object.values(changedFields)[0]);
                setShowBasicFlag(true);
              } else {
                setShowBasicFlag(false);
              }
            }
          }}
        >
          {jiraFormData &&
            jiraFormData?.data?.map((item: JiraFormItemType, index: number) => {
              const { label, name, rules, rulesMessage, itemType } = item;
              let formNode = null;
              switch (itemType) {
                case 'radio':
                  formNode = (
                    <Radio.Group
                      name={name}
                      options={radioOptionsMap.get(name)}
                    ></Radio.Group>
                  );
                  break;
                case 'input':
                  formNode = (
                    <Input
                      name={name}
                      placeholder={item && item.placeholder}
                      maxLength={item.maxLength || 50}
                    />
                  );
                  break;
                case 'textArea':
                  formNode = (
                    <TextArea
                      name={name}
                      placeholder={item && item.placeholder}
                      maxLength={500}
                      showCount
                    />
                  );
                  break;
                case 'select':
                  formNode = (
                    <Select
                      placeholder={item && item.placeholder}
                      filterOption={item.name === 'componentId'}
                      options={selectOptionsMap.get(name)}
                    />
                  );
                  break;
                case 'custom':
                  formNode = (
                    <>
                      <Select
                        mode='multiple'
                        style={{ width: '90%' }}
                        value={timeList}
                        onChange={handleSelectTime}
                        open={false}
                        className={`pickerSelect ${
                          timeList.length === 0 ? '' : 'select-time'
                        }`}
                      ></Select>
                      <DatePicker
                        showTime
                        onChange={changeTime}
                        onOk={onOk}
                        style={{ width: '10%' }}
                        inputReadOnly={true}
                        className='defaultIcon'
                        allowClear={false}
                      />
                    </>
                  );
                  break;
                case 'upload':
                  formNode = (
                    <Upload
                      customRequest={customRequest}
                      onRemove={onRemove}
                      fileList={showImgList}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        disabled={showImgList.length >= 3}
                      >
                        点击上传截图
                      </Button>
                    </Upload>
                  );
                  break;
                default:
                  return;
              }
              return item.itemType === 'custom' ? (
                <Form.Item
                  label={
                    <>
                      <span className='required-label'>{label}</span>
                    </>
                  }
                  name={name}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (timeList.length > 0) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error(rulesMessage));
                      },
                    }),
                  ]}
                  key={index}
                  hidden={!!item.hidden}
                >
                  {formNode}
                </Form.Item>
              ) : (
                <Form.Item
                  label={label}
                  name={name}
                  rules={[{ required: rules, message: rulesMessage }]}
                  key={index}
                  hidden={!!item.hidden}
                >
                  {formNode}
                </Form.Item>
              );
            })}
        </Form>
      </div>
    );
  };

  return (
    <Modal
      title={props.title || '问题提报'}
      visible={modalVisible}
      className='my-modal re-modal'
      width='664px'
      onCancel={(e) => {
        handleClose();
      }}
      confirmLoading={loading}
      onOk={debounce(submit, 1000)}
      okButtonProps={{ htmlType: 'submit', form: 'problemForm' }}
      okText='提交'
      cancelText='取消'
      maskClosable={false}
    >
      {renderJiraForm()}
    </Modal>
  );
};

export const showJiraModal = (options: Props) => {
  const {
    jiraItem,
    alarmItem,
    basicItem,
    title,
    issueNo,
    vehicleName,
    stationName,
    accidentNo,
    onClose,
    submitTime,
    accidentData,
  } = options;
  let mountNode = document.getElementById('jiraModal');
  if (!mountNode) {
    mountNode = document.createElement('div');
    mountNode.setAttribute('id', 'jiraModal');
    document.body.appendChild(mountNode);
  }
  ReactDOM.render(
    <OptimizeJira
      vehicleName={vehicleName}
      title={title}
      stationName={stationName}
      jiraItem={jiraItem}
      alarmItem={alarmItem}
      basicItem={basicItem}
      // alarmList={alarmList}
      issueNo={issueNo}
      onClose={onClose}
      accidentNo={accidentNo}
      submitTime={submitTime}
      accidentData={accidentData}
    />,
    mountNode,
  );
};
export default OptimizeJira;
